const json = {
    GE: {
        BEEN_IN_GEORGIA: 'გიმოგზაურიათ საქართველოში?',
        POSTS_ANALYZED: 'შეამოწმეთ, თუ გაანალიზდა თქვენი პოსტები',
        USERNAME_PLACEHOLDER: 'ინსტაგრამის, facebook-ის ან ტვიტერის მომხმარებელი',
        CHECK: 'შეამოწმე',
        BEAR_IN_MIND: 'გთხოვთ გაითვალისწინოთ, რომ ჩვენ მხოლოდ ღია (public) პოსტებს ვამოწმებთ',
        NOT_FOUND: 'თქვენი პოსტები არ მოიძებნა',
        CLOSE: 'დახურვა',
        SHARE: 'გაზიარება',
        SELECTED_POSTS: 'არჩეული პოსტები',
        APPRECIATIONS: 'მოწონება'
    },
    EN: {
        BEEN_IN_GEORGIA: 'Have you been to Georgia recently?',
        POSTS_ANALYZED: 'Check if your posts have been analyzed',
        USERNAME_PLACEHOLDER: 'Instagram, Facebook or Twitter Username',
        CHECK: 'Check',
        BEAR_IN_MIND: 'Please bear in mind that we only check public posts',
        NOT_FOUND: 'Sorry, we can\'t find anything with this username',
        CLOSE: 'Close',
        SHARE: 'SHARE',
        SELECTED_POSTS: 'Selected Posts',
        APPRECIATIONS: 'Appreciations'
    }
}

export default json



// WEBPACK FOOTER //
// ./client/app/components/home/contributor/contributor.texts.js